/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Ce } from './Ce';

class CertExamApply extends Ce {
    constructor() {
        super();
        this.baseUrl += '/certExamApply';
    }

    findCertExamApplyList(queryData) {
        let examApplyBeginTime = null;
        let examApplyEndTime = null;
        if (queryData.examApplyTime != null && queryData.examApplyTime.length === 2) {
            [examApplyBeginTime, examApplyEndTime] = queryData.examApplyTime;
        }
        let updateBeginTime = null;
        let updateEndTime = null;
        if (queryData.updateTime != null && queryData.updateTime.length === 2) {
            [updateBeginTime, updateEndTime] = queryData.updateTime;
        }
        let originalReviewTimeBegin = null;
        let originalReviewTimeEnd = null;
        if (queryData.originalReviewTime != null && queryData.originalReviewTime.length === 2) {
            [originalReviewTimeBegin, originalReviewTimeEnd] = queryData.originalReviewTime;
        }
        let originalMustReviewTimeBegin = null;
        let originalMustReviewTimeEnd = null;
        if (queryData.originalMustReviewTime != null && queryData.originalMustReviewTime.length === 2) {
            [originalMustReviewTimeBegin, originalMustReviewTimeEnd] = queryData.originalMustReviewTime;
        }
        return super.get('/findCertExamApplyList', {
            ...queryData,
            examApplyBeginTime,
            examApplyEndTime,
            updateBeginTime,
            updateEndTime,
            originalReviewTimeBegin,
            originalReviewTimeEnd,
            originalMustReviewTimeBegin,
            originalMustReviewTimeEnd,
            colorMarkList: queryData.colorMarkList ? queryData.colorMarkList.join(',') : '',
        });
    }

    getCertExamApplyDetail({ id }) {
        return super.get('/getCertExamApplyDetail', { id });
    }

    submit({ ids, applyStatus, auditOpinion, notPassIds } = {}) {
        return super.post('/submit', {
            ids,
            applyStatus,
            auditOpinion,
            notPassIds,
        });
    }

    cancel({ ids } = {}) {
        return super.post('/cancel', {
            ids,
        });
    }

    reviewExpiration({ ids } = {}) {
        return super.post('/reviewExpiration', {
            ids,
        });
    }

    changeCertExamApplyType({ id, certExamApplyType } = {}) {
        return super.post('/changeCertExamApplyType', {
            id,
            certExamApplyType,
        });
    }

    applyMaterialsAudit({ ids, applyMaterialsIds, applyMaterialsStatus } = {}) {
        return super.post('/applyMaterialsAudit', {
            ids,
            applyMaterialsIds,
            applyMaterialsStatus,
        });
    }

    updateMaterialSubmissionTime({ id } = {}) {
        return super.post('/updateMaterialSubmissionTime', {
            id,
        });
    }

    setIssuedCertificate({ ids } = {}) {
        return super.post('/setIssuedCertificate', {
            ids,
        });
    }

    createGrouping({
        ids,
        verticalGroupingSn,
        verticalGroupingName,
        theoryExamTimeBegin,
        theoryExamTimeEnd,
        practiceExamTimeBegin,
        practiceExamTimeEnd,
        verticalGroupingDesc,
    } = {}) {
        return super.post('/createGrouping', {
            ids,
            verticalGroupingSn,
            verticalGroupingName,
            theoryExamTimeBegin,
            theoryExamTimeEnd,
            practiceExamTimeBegin,
            practiceExamTimeEnd,
            verticalGroupingDesc,
        });
    }

    createGrouping2({ ids } = {}) {
        return super.post('/createGrouping2', {
            ids,
        });
    }

    relatedGrouping({ ids, verticalGroupingId } = {}) {
        return super.post('/relatedGrouping', {
            ids,
            verticalGroupingId,
        });
    }

    applyMaterialsDetail({ certExamApplyId, applyMaterialsId }) {
        return super.get('/applyMaterialsDetail', { certExamApplyId, applyMaterialsId });
    }

    saveApplyMaterials({ certExamApplyId, applyMaterialsId, applyMaterialsValue }) {
        return super.post('/saveApplyMaterials', { certExamApplyId, applyMaterialsId, applyMaterialsValue });
    }

    transferGrouping({ ids, verticalGroupingId, oldVerticalGroupingId } = {}) {
        return super.post('/transferGrouping', {
            ids,
            verticalGroupingId,
            oldVerticalGroupingId,
        });
    }

    editDeliveryInfo({
        id,
        shipMethod,
        deliveryConsignee,
        deliveryPhone,
        deliveryRegionId,
        deliveryAddress,
        companyName,
        workRegionId,
    }) {
        return super.post('/editDeliveryInfo', {
            id,
            shipMethod,
            deliveryConsignee,
            deliveryPhone,
            deliveryRegionId,
            deliveryAddress,
            companyName,
            workRegionId,
        });
    }

    batchSetMaterialsTimeout({ verticalGroupingId, ids, materialsIds }) {
        return super.post('/batchSetMaterialsTimeout', { verticalGroupingId, ids, materialsIds });
    }
}

export default new CertExamApply();
export { CertExamApply };
